import { useState, useEffect } from 'react';
import { Plus, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../App';

export const FloatingActionButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const navigate = useNavigate();
  const { user, login } = useAuth();

  useEffect(() => {
    const handleScroll = () => {
      // Show FAB after scrolling 300px
      setIsVisible(window.scrollY > 300);
      // Glass effect after scrolling 500px
      setIsScrolled(window.scrollY > 500);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleClick = () => {
    if (user) {
      navigate('/submit');
    } else {
      login();
    }
  };

  if (!isVisible) return null;

  return (
    <button
      onClick={handleClick}
      className={`fab ${isScrolled ? 'fab-glass' : ''}`}
      data-testid="fab-submit"
      aria-label="Submit placement"
    >
      <Plus className="h-5 w-5" />
      <span className="hidden sm:inline">Submit Placement</span>
    </button>
  );
};

export default FloatingActionButton;
